import apiClient from "./api/axiosClient";

export async function downloadFile(filePath, type = "download") {
  try {
    if (!filePath) {
      alert(`invalid path :: ${filePath}`);
      return;
    }
    const res = await apiClient.get("/auth/download/", {
      params: { path: filePath },
      responseType: "blob", // must be blob
    });

    // Get filename from Content-Disposition (if Django sends it)
    const contentDisposition = res.headers["content-disposition"];
    let fileName = filePath.split("/").pop() || "download.pdf";
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+)"/);
      if (match?.[1]) fileName = match[1];
    }

    if (type === "file") {
      return res.data;
    }

    // res.data is already a Blob
    const url = window.URL.createObjectURL(res.data);

    // Create link and trigger download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    // Clean up
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download error:", error);
    alert(`Error :: ${error.message || error}`);
  }
}

export function getUserDetails() {
  let userData = "";
  try {
    userData = sessionStorage.getItem("user_info");
    if (!userData) {
      throw new Error("unable to get userinfo in Session Storage.");
    }
    userData = JSON.parse(userData);
  } catch (error) {
    alert(`Error :: Geting user Info :: ${error}`);
  }

  return userData ? userData : null;
}
